const colorData=  [
  {
    "letter": "neela",
    "harf": "نیلا",
    "soundFile": "neela.mp3",
    "words": [
      {
        "word": "نیلی گاڑی",
        "imageFile": "neela_01.jpg",
        "soundFile": "neela_01.mp3"
      },
      {
        "word": "نیلی تتلی",
        "imageFile": "neela_02.jpg",
        "soundFile": "neela_02.mp3"
      },
      {
        "word": "نیلی آنکھ",
        "imageFile": "neela_03.jpg",
        "soundFile": "neela_03.mp3"
      },
      {
        "word": "نیلا پھول",
        "imageFile": "neela_04.jpg",
        "soundFile": "neela_04.mp3"
      },
      {
        "word": "نیلی چڑیا",
        "imageFile": "neela_05.jpg",
        "soundFile": "neela_05.mp3"
      },             
      {              
        "word": "نیلا آسمان",
        "imageFile": "neela_06.jpg",
        "soundFile": "neela_06.mp3"
      }
    ]
  },
  {
    "letter": "peela",
    "harf": "پیلا",
    "soundFile": "peela.mp3",
    "words": [
      {
        "word": "پیلی گیند",
        "imageFile": "peela_01.jpg",
        "soundFile": "peela_01.mp3"
      },             
      {              
        "word": "پیلی گاڑی",
        "imageFile": "peela_02.jpg",
        "soundFile": "peela_02.mp3"
      },             
      {              
        "word": "پیلے پھول",
        "imageFile": "peela_03.jpg",
        "soundFile": "peela_03.mp3"
      },             
      {              
        "word": "پیلے پتے",
        "imageFile": "peela_04.jpg",
        "soundFile": "peela_04.mp3"
      },             
      {              
        "word": "پیلا لیموں",
        "imageFile": "peela_05.jpg",
        "soundFile": "peela_05.mp3"
      },             
      {              
        "word": "پیلا پرندہ",
        "imageFile": "peela_06.jpg",
        "soundFile": "peela_06.mp3"
      }
    ]
  },
  {
    "letter": "laal",
    "harf": "لال",
    "soundFile": "laal.mp3",
    "words": [
      {
        "word": "لال پنسل",
        "imageFile": "laal_01.jpg",
        "soundFile": "laal_01.mp3"
      },             
      {              
        "word": "لال ٹماٹر",
        "imageFile": "laal_02.jpg",
        "soundFile": "laal_02.mp3"
      },             
      {              
        "word": "لال طوطا",
        "imageFile": "laal_03.jpg",
        "soundFile": "laal_03.mp3"
      },             
      {              
        "word": "لال گاڑی",
        "imageFile": "laal_04.jpg",
        "soundFile": "laal_04.mp3"
      },             
      {              
        "word": "لال پھول",
        "imageFile": "laal_05.jpg",
        "soundFile": "laal_05.mp3"
      },             
      {              
        "word": "لال مرچیں",
        "imageFile": "laal_06.jpg",
        "soundFile": "laal_06.mp3"
      }
    ]
  },
  {
    "letter": "hara",
    "harf": "ہرا",
    "soundFile": "hara.mp3",
    "words": [
      {
        "word": "ہرے انگور",
        "imageFile": "hara_01.jpg",
        "soundFile": "hara_01.mp3"
      },
      {
        "word": "ہرا سانپ",
        "imageFile": "hara_02.jpg",
        "soundFile": "hara_02.mp3"
      },
      {
        "word": "ہرا کھیت",
        "imageFile": "hara_03.jpg",
        "soundFile": "hara_03.mp3"
      },
      {
        "word": "ہرے دانے",
        "imageFile": "hara_04.jpg",
        "soundFile": "hara_04.mp3"
      },
      {
        "word": "ہرے پتے",
        "imageFile": "hara_05.jpg",
        "soundFile": "hara_05.mp3"
      },
      {
        "word": "ہری گاڑی",
        "imageFile": "hara_06.jpg",
        "soundFile": "hara_06.mp3"
      }
    ]
  },
  {
    "letter": "naranji",
    "harf": "نارنجی",
    "soundFile": "naranji.mp3",
    "words": [
      {
        "word": "نارنجی بلی",
        "imageFile": "naranji_01.jpg",
        "soundFile": "naranji_01.mp3"
      },
      {
        "word": "نارنجی پھول",
        "imageFile": "naranji_02.jpg",
        "soundFile": "naranji_02.mp3"
      },
      {
        "word": "نارنجی پنسل",
        "imageFile": "naranji_03.jpg",
        "soundFile": "naranji_03.mp3"
      },
      {
        "word": "نارنجی درخت",
        "imageFile": "naranji_04.jpg",
        "soundFile": "naranji_04.mp3"
      },
      {
        "word": "نارنجی سنگترے",
        "imageFile": "naranji_05.jpg",
        "soundFile": "naranji_05.mp3"
      },
      {
        "word": "نارنجی گاڑی",
        "imageFile": "naranji_06.jpg",
        "soundFile": "naranji_06.mp3"
      }
    ]
  },
  {
    "letter": "safaid",
    "harf": "سفید",
    "soundFile": "safaid.mp3",
    "words": [
      {
        "word": "سفید گیند",
        "imageFile": "safaid_01.jpg",
        "soundFile": "safaid_01.mp3"
      },
      {
        "word": "سفید گھوڑے",
        "imageFile": "safaid_02.jpg",
        "soundFile": "safaid_02.mp3"
      },
      {
        "word": "سفید کبوتر",
        "imageFile": "safaid_03.jpg",
        "soundFile": "safaid_03.mp3"
      },
      {
        "word": "سفید پھول",
        "imageFile": "safaid_04.jpg",
        "soundFile": "safaid_04.mp3"
      },
      {
        "word": "سفید بلی",
        "imageFile": "safaid_05.jpg",
        "soundFile": "safaid_05.mp3"
      },
      {
        "word": "سفید بطخ",
        "imageFile": "safaid_06.jpg",
        "soundFile": "safaid_06.mp3"
      }
    ]
  },
  {
    "letter": "kala",
    "harf": "کالا",
    "soundFile": "kala.mp3",
    "words": [
      {
        "word": "کالا راج ہنس",
        "soundFile": "kala_01.mp3",
        "imageFile": "kala_01.jpg"
      },
      {
        "word": "کالا کوا",
        "imageFile": "kala_02.jpg",
        "soundFile": "kala_02.mp3"
      },
      {
        "word": "کالا گدھ",
        "imageFile": "kala_03.jpg",
        "soundFile": "kala_03.mp3"
      },
      {
        "word": "کالی بلی",
        "imageFile": "kala_04.jpg",
        "soundFile": "kala_04.mp3"
      },
      {
        "word": "کالی تتلی",
        "imageFile": "kala_05.jpg",
        "soundFile": "kala_05.mp3"
      },
      {
        "word": "کالی مکڑی",
        "imageFile": "kala_06.jpg",
        "soundFile": "kala_06.mp3"
      }
    ]
  },
  {
    "letter": "bhoora",
    "harf": "بھورا",
    "soundFile": "bhoora.mp3",
    "words": [
      {
        "word": "بھورا پرندہ",
        "imageFile": "bhoora_01.jpg",
        "soundFile": "bhoora_01.mp3"
      },
      {
        "word": "بھورا ریچھ",
        "imageFile": "bhoora_02.jpg",
        "soundFile": "bhoora_02.mp3"
      },
      {
        "word": "بھورا سانپ",
        "imageFile": "bhoora_03.jpg",
        "soundFile": "bhoora_03.mp3"
      },
      {
        "word": "بھورا گھوڑا",
        "imageFile": "bhoora_04.jpg",
        "soundFile": "bhoora_04.mp3"
      },
      {
        "word": "بھوری تتلی",
        "imageFile": "bhoora_05.jpg",
        "soundFile": "bhoora_05.mp3"
      },
      {
        "word": "بھوری لکڑی",
        "imageFile": "bhoora_06.jpg",
        "soundFile": "bhoora_06.mp3"
      }
    ]
  }
];

export default colorData;
